import apiClient from '../api';
import { CoachInvite, CoachClient, MyCoach, ClientSummary, CompetitionCalendarEntry } from '../../types';

const coachService = {
  /** Generate a new invite code (bodybuilder calls this) */
  generateInvite: async (): Promise<CoachInvite> => {
    const response = await apiClient.post<CoachInvite>('/coach/generate-invite');
    return response.data;
  },

  /** List all invites generated by the current bodybuilder */
  getMyInvites: async (): Promise<CoachInvite[]> => {
    const response = await apiClient.get<CoachInvite[]>('/coach/my-invites');
    return response.data;
  },

  /** Delete an unused invite */
  deleteInvite: async (inviteId: string): Promise<void> => {
    await apiClient.delete(`/coach/invites/${inviteId}`);
  },

  /** List coaches who have access to the bodybuilder's data */
  getMyCoaches: async (): Promise<MyCoach[]> => {
    const response = await apiClient.get<MyCoach[]>('/coach/my-coaches');
    return response.data;
  },

  /** Redeem an invite code (coach calls this) */
  redeemInvite: async (code: string): Promise<{ message: string; athleteName: string; athleteEmail: string }> => {
    const response = await apiClient.post('/coach/redeem-invite', { code });
    return response.data;
  },

  /** List all coached athletes */
  getClients: async (): Promise<CoachClient[]> => {
    const response = await apiClient.get<CoachClient[]>('/coach/clients');
    return response.data;
  },

  /** Revoke a coach relationship (either party can call) */
  revokeRelationship: async (relationshipId: string): Promise<void> => {
    await apiClient.delete(`/coach/clients/${relationshipId}`);
  },

  /** Get summary card data for all coached athletes */
  getClientSummaries: async (): Promise<ClientSummary[]> => {
    const response = await apiClient.get<ClientSummary[]>('/coach/client-summaries');
    return response.data;
  },

  /** Get all upcoming shows (≤1 year) for all coached athletes, sorted by date */
  getCompetitionCalendar: async (): Promise<CompetitionCalendarEntry[]> => {
    const response = await apiClient.get<CompetitionCalendarEntry[]>('/coach/competition-calendar');
    return response.data;
  },
};

export default coachService;
